import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const languages = ['en', 'hi', 'es', 'pt'] as const;
const namespaces = ['general', 'user_config', 'clinic_config'] as const;

type Language = typeof languages[number];
type Namespace = typeof namespaces[number];
type NamespaceResource = Record<string, string>;
type LanguageResource = Record<Namespace, NamespaceResource>;
type TranslationResources = Record<Language, LanguageResource>;

async function loadResources(): Promise<TranslationResources> {
  const resources: Partial<Record<Language, Partial<LanguageResource>>> = {};

  for (const lang of languages) {
    resources[lang] = {};

    for (const ns of namespaces) {
      try {
        const module = await import(`../locales/${lang}/${ns}.json`);
        resources[lang]![ns] = module.default as NamespaceResource;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`⚠️ Missing translation file: ../locales/${lang}/${ns}.json`, e);
      }
    }
  }

  return resources as TranslationResources;
}

(async () => {
  const resources = await loadResources();

  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      lng: 'en',
      fallbackLng: 'en',
      ns: [...namespaces],
      defaultNS: 'common',
      interpolation: {
        escapeValue: false
      }
    });
})();

export default i18n;
